<template>
    <div class="panel-group">
        <div :class="['panel','panel-default','nav-list-item',(navItems.open)?'active':'']">
            <a class="nav-list-item-link-tab" @click.prevent="navMainToggle">
                <div class="nav-list-item-link-content">
                    <div class="nav-list-item-icon"
                         :style="[(navItems.icon_type == 'fontawesome')?{'font-size':'none'}:{'font-size':'0'}]">
                        <i v-if="(navItems.icon_type == 'fontawesome')" :class="['fas',navItems.icon]"></i>
                        <svg v-if="(navItems.icon_type == 'svg')" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 130 130.05">
                            <use :xlink:href="navItems.icon"></use>
                        </svg>
                    </div>
                    <span class="nav-list-item-title">{{navItems.text}}
                        <i v-if="(oneOrMoreInstalled)" class="fas fa-circle fa-xs"></i>
                    </span>
                    <span v-if="(navItems.subs.length > 0)">
                        <i v-show="navItems.open" class="fas fa-angle-up collapse-icon"></i>
                        <i v-show="(!navItems.open)" class="fas fa-angle-down collapse-icon"></i>
                    </span>
                </div>
            </a>
            <zoom-y-transition>
                <ul v-if="((navItems.subs.length > 0) && (navItems.open))" :class="['panel-body','nav-sub-list']">
                    <li :class="['nav-sub-item','nav-sub-item-nth-child-'+navIndex,(activeContent.id && activeContent.id == navSubItem.id)?'active':'']"
                        v-for="(navSubItem,navSubItemIndex) in navItems.subs" :key="navSubItemIndex">
                        <a class="nav-sub-item-link" href="#"
                           @click.prevent="activeContentChange(navSubItem.id,navSubItem.type)"
                           :name="navSubItem.id">
                            {{navSubItem['text']}}
                            <i v-if="(isInstalledByType(navSubItem.type))" class="fas fa-circle fa-xs"></i>
                        </a>
                    </li>
                </ul>
            </zoom-y-transition>
        </div>
    </div>
</template>

<script>
    import {ZoomYTransition} from 'vue2-transitions'

    export default {
        props: ['navItems', 'activeContent', 'nav-index'],
        data: function () {
            return {
                'oneOrMoreInstalled': false
            };
        },
        methods: {
            isInstalledByType: function (type) {
                let isInstalled = this.$parent.isInstalledByType(type);
                this.oneOrMoreInstalled = (this.oneOrMoreInstalled) ? true : isInstalled;
                return isInstalled;
            },
            navMainToggle: function () {
                let originalState = this.navItems.open; //original state before run closeAllNav function
                this.$parent.closeAllNav();
                if (this.navItems.subs.length == 0) {
                    this.activeContentChange(this.navItems.id, this.navItems.type, this.navItems.subOpen);
                    this.navItems.open = true;
                    return;
                }
                this.navItems.open = !originalState;
            },
            activeContentChange: function (content, type, subOpen = null) {
                this.$parent.$parent.activeContentChange(content, type, subOpen);
            }
        },
        components: {
            ZoomYTransition
        },
        watch: {
            activeContent: {
                deep: false,
                immediate: false,
                handler() {
                    /** Check if category is installed*/
                    if (this.navItems.subs.length > 0) {
                        for (let nav in this.navItems.subs) {
                            let type = this.navItems.subs[nav].type;
                            if(type){
                                this.isInstalledByType(type);
                            }
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .fa-xs {
        font-size: 8px;
        color: #2ecc71;
    }

    .nav-sub-list {
        padding: 10px 0 10px 95px;
        border-top: 1px solid #e1e1e1;
        background-color: #fafafa;
        overflow: hidden;
    }


    .nav-sub-item {
        position: relative;
        display: block;
    }

    .nav-sub-item a {
        font-size: 15px;
        line-height: 2.5em;
        color: #8CA2A0;
        text-decoration: none;
        display: block;
        max-width: 188px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .nav-sub-item:before {
        content: '';
        width: 20px;
        border-top: 1px solid #eaeaea;
        position: absolute;
        left: -36px;
        top: 50%;
        transition: all .3s;
        pointer-events: none;
    }


    .nav-sub-item:after {
        content: '';
        position: absolute;
        left: -36px;
        top: 0;
        height: calc(100% - 27px);
        width: 1px;
        background-color: #eaeaea;
        pointer-events: none;
    }

    .nav-sub-item-nth-child-0:after {
        top: -10px;
        height: calc(100% / 2 + 10px);
    }

    .nav-sub-item-nth-child-1:after {
        top: calc(-100% - 10px);
        height: calc(200% - 8px);
    }

    .nav-sub-item-nth-child-2:after {
        top: calc(-200% - 10px);
        height: calc(300% - 8px);
    }

    .nav-sub-item-nth-child-3:after {
        top: calc(-300% - 10px);
        height: calc(400% - 8px);
    }

    .nav-sub-item-nth-child-4:after {
        top: calc(-400% - 10px);
        height: calc(500% - 8px);
    }

    .nav-sub-item:hover:before, .nav-sub-item:hover:after,
    .nav-sub-item.active:before, .nav-sub-item.active:after {
        border-color: #696969;
        background-color: #696969;
        z-index: 1;
    }

    .nav-sub-item-link {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .nav-items-list .nav-list-item {
        border-bottom: 1px solid #fff;
    }

    .nav-list-item {
        display: block;
        list-style-type: none;
        width: 100%;
        flex: 1;
    }

    .panel-default {
        position: relative;
    }

    .nav-list-item {
        --main-svg-color: #5C5C5C;
        --secondary-svg-color: #5C5C5C;
        cursor: pointer;
    }

    .nav-list-item.active {
        background-color: #D3D3D3;
    }

    .nav-list-item-link-tab {
        display: flex;
        align-items: center;
        padding: 25px 40px;
        color: inherit;
        text-decoration: none;
        height: 100%;
    }

    .nav-list-item-link-content {
        width: 100%;
        position: relative;
    }

    .nav-list-item-icon {
        width: 40px;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        transition: all .3s;
    }

    .nav-list-item-title {
        display: inline-block;
        margin-left: 20px;
        color: #5C5C5C;
        font-size: 16px;
        max-width: calc(100% - 75px);
        vertical-align: middle;
        font-weight: 500;
        position: relative;
        text-transform: capitalize;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .collapse-icon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        color: #a7a7a7;
    }

    .nav-sub-item.active .nav-sub-item-link {
        color: #D3D3D3;
    }

    /*
    *****************************
        safely
    *****************************
    */

    .safely .nav-list-item .nav-list-item-icon, .nav-list-item.active.extension-activated .collapsed .nav-list-item-icon {
        --main-svg-color: #5c5c5c;
        --secondary-svg-color: #5c5c5c;
        opacity: .7;
    }

    .safely .nav-list-item.active {
        background-color: #E5F6FE;
    }

    .safely .nav-list-item.active .nav-list-item-title {
        color: #03a9f4;
    }

    .safely .nav-sub-item.active .nav-sub-item-link {
        color: #03a9f4;
    }

    .safely .nav-sub-item.active .nav-sub-item-link {
        color: #03a9f4;
    }

    .safely .nav-sub-item a:hover {
        color: #03a9f4;
    }

    .safely .nav-sub-item:hover:before, .safely .nav-sub-item:hover:after,
    .safely .nav-sub-item.active:before, .safely .nav-sub-item.active:after {
        border-color: #03a9f4;
        background-color: #03a9f4;
    }

    /*
    *****************************
        privately
    *****************************
    */

    .privately .nav-list-item-icon {
        color: #02aa87;
    }

    .privately .nav-sub-item a:hover {
        color: #01ccae;
    }

    .nav-sub-item.active .nav-sub-item-link {
        color: #00cdad;
    }

    /*
    *****************************
        online-tools
    *****************************
    */
    .onlinetools .nav-list-item-title {
        color: #243665;
    }

    .onlinetools .nav-list-item.active {
        background-color: #ede0c2;
    }

    .onlinetools .nav-sub-list a {
        color: #243665;
    }

    .onlinetools .nav-sub-item a:hover {
        color: #1e98e2;
    }

    .onlinetools .nav-sub-item.active .nav-sub-item-link {
        color: #243665
    }

    .onlinetools .nav-sub-item.active :hover {
        color: #1e98e2;
    }

</style>